// Copyright 2026 Mo-Sys Engineering Ltd. All Rights Reserved.
import { store } from "../../../store/store";

import {
  fetchPresets,
  fetchPresetSequencesForGroup,
  fetchControlGroupById,
} from "../../../store/equipment/equipmentActions";

import { clearSelectedPresetSequence } from "../../../store/equipment/equipmentSlice";

export async function controlLoader({ params }) {
  const { cameraGroupId } = params;

  if (!cameraGroupId) {
    return null;
  }
  store.dispatch(clearSelectedPresetSequence());

  await Promise.all([
    store.dispatch(fetchControlGroupById(cameraGroupId)),
    store.dispatch(fetchPresets(cameraGroupId)),
    store.dispatch(fetchPresetSequencesForGroup(cameraGroupId)),
  ]);

  return null;
}

controlLoader.hydrate = true;
